// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { LockArgs_abstract } from './../../abstract/SagaBase/Defines/LockArgs_abstract';
export class LockArgs extends LockArgs_abstract {}
